export const SITE_URL = 'https://lebleudeschamps.ca';

export const SEO_BY_PATH = {
  '/': {
    title: 'Le Bleu des Champs | Climatisation et chauffage à Saint-Césaire',
    description: 'Installation, entretien et réparation de climatisation, chauffage, ventilation et électroménagers à Saint-Césaire depuis 1977.',
    index: true,
  },
  '/services': {
    title: 'Services de climatisation, chauffage et électroménagers | Le Bleu des Champs',
    description: 'Découvrez nos services de climatisation, chauffage, ventilation, nettoyage et réparation d’électroménagers en Montérégie.',
    index: true,
  },
  '/soumission': {
    title: 'Demande de soumission | Le Bleu des Champs',
    description: 'Demandez gratuitement une soumission pour vos besoins en climatisation, chauffage, ventilation ou électroménagers.',
    index: true,
  },
  '/demande-service': {
    title: 'Demande de service | Le Bleu des Champs',
    description: 'Transmettez une demande de service à l’équipe du Bleu des Champs à Saint-Césaire.',
    index: true,
  },
  '/a-propos': {
    title: 'À propos | Le Bleu des Champs',
    description: 'Découvrez l’histoire de cette entreprise familiale de Saint-Césaire au service de votre confort depuis 1977.',
    index: true,
  },
  '/commande-piece': {
    title: 'Commander une pièce d’électroménager | Le Bleu des Champs',
    description: 'Demandez une pièce pour votre électroménager et recevez une confirmation de disponibilité et de prix.',
    index: true,
  },
  '/demande-nettoyage': {
    title: 'Demande de nettoyage | Le Bleu des Champs',
    description: 'Demandez le nettoyage professionnel de votre échangeur d’air ou de votre thermopompe.',
    index: true,
  },
  '/politique-confidentialite': {
    title: 'Politique de confidentialité | Le Bleu des Champs',
    description: 'Consultez la politique de confidentialité et les pratiques de protection des renseignements personnels du Bleu des Champs.',
    index: true,
  },
  '/connexion': {
    title: 'Connexion | Le Bleu des Champs',
    description: 'Accès sécurisé à l’espace de gestion du Bleu des Champs.',
    index: false,
  },
  '/reset-password': {
    title: 'Réinitialisation du mot de passe | Le Bleu des Champs',
    description: 'Réinitialisez le mot de passe de votre espace de gestion.',
    index: false,
  },
};

export function getSeoForPath(pathname) {
  if (pathname.startsWith('/dashboard')) {
    return {
      title: 'Espace de gestion | Le Bleu des Champs',
      description: 'Espace de gestion privé du Bleu des Champs.',
      index: false,
    };
  }
  return SEO_BY_PATH[pathname] || {
    title: 'Page introuvable | Le Bleu des Champs',
    description: 'La page demandée est introuvable.',
    index: false,
  };
}
